module.exports = __webpack_public_path__ + "img/CB4-Off-1.20792263.gif";